// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vod-message-bar {
  display: grid;
  background: #ffffff;
  border: 1.5px solid #1a6a7c;
  border-radius: 1.5vw;
  text-align: center;
  padding: 0.1vw;
  margin: 0.1vw;
  color: #1a6a7c;
  font-size: 1.2vw;
}
.vod-top-bar-button {
  display: grid;
  grid-template-columns: 73vw auto;
  gap: 1.5vw;
  align-items: end;
}
.vod-top-bar {
  display: grid;
  grid-template-columns: 12.2vw auto 2.5vw;
  height: min-content;
  gap: 0.5vw;
}

.vod-button-setting {
  display: grid;
  place-items: center;
  width: 12.2vw;
  grid-template-columns: repeat(4, max-content);
  gap: 0.5vw;
}

.vod-icon {
  height: 2.2vw;
}
.vod-icon:not(.blocked):active {
  filter: brightness(0.8);
}
.vod-icon.blocked {
  filter: brightness(0.6);
  cursor: not-allowed;
  opacity: 0.8;
}
.vod-next {
  height: 2.2vw;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
}
.vod-nextButton {
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  height: 5vw;
}

.vod-auxButtons {
  display: grid;
  height: 5vw;
  row-gap: 0.7vw;
  justify-self: center;
  column-gap: 1vw;
}
.vod-transButtons {
  display: grid;
  column-gap: 1vw;
  row-gap: 0.5vw;
  justify-self: center;
  grid-template-columns: repeat(3, 3.4vw);
}

.vod-icon-transButtons {
  display: grid;
  height: 2.2vw;
  width: 100%;
}
.vod-icon-transButtons.blocked {
  filter: brightness(0.8);
  cursor: not-allowed;
  opacity: 0.8;
}
.vod-icon-transButtons:not(.blocked):active {
  filter: brightness(0.8);
}
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/Vodyanoy/styles/TopBar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gCAAgC;EAChC,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,wCAAwC;EACxC,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,6CAA6C;EAC7C,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,aAAa;EACb,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,cAAc;EACd,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,uBAAuB;AACzB","sourcesContent":[".vod-message-bar {\n  display: grid;\n  background: #ffffff;\n  border: 1.5px solid #1a6a7c;\n  border-radius: 1.5vw;\n  text-align: center;\n  padding: 0.1vw;\n  margin: 0.1vw;\n  color: #1a6a7c;\n  font-size: 1.2vw;\n}\n.vod-top-bar-button {\n  display: grid;\n  grid-template-columns: 73vw auto;\n  gap: 1.5vw;\n  align-items: end;\n}\n.vod-top-bar {\n  display: grid;\n  grid-template-columns: 12.2vw auto 2.5vw;\n  height: min-content;\n  gap: 0.5vw;\n}\n\n.vod-button-setting {\n  display: grid;\n  place-items: center;\n  width: 12.2vw;\n  grid-template-columns: repeat(4, max-content);\n  gap: 0.5vw;\n}\n\n.vod-icon {\n  height: 2.2vw;\n}\n.vod-icon:not(.blocked):active {\n  filter: brightness(0.8);\n}\n.vod-icon.blocked {\n  filter: brightness(0.6);\n  cursor: not-allowed;\n  opacity: 0.8;\n}\n.vod-next {\n  height: 2.2vw;\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-end;\n}\n.vod-nextButton {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-end;\n  height: 5vw;\n}\n\n.vod-auxButtons {\n  display: grid;\n  height: 5vw;\n  row-gap: 0.7vw;\n  justify-self: center;\n  column-gap: 1vw;\n}\n.vod-transButtons {\n  display: grid;\n  column-gap: 1vw;\n  row-gap: 0.5vw;\n  justify-self: center;\n  grid-template-columns: repeat(3, 3.4vw);\n}\n\n.vod-icon-transButtons {\n  display: grid;\n  height: 2.2vw;\n  width: 100%;\n}\n.vod-icon-transButtons.blocked {\n  filter: brightness(0.8);\n  cursor: not-allowed;\n  opacity: 0.8;\n}\n.vod-icon-transButtons:not(.blocked):active {\n  filter: brightness(0.8);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
